import { Constructor } from "@slhuicore/base/constructor.js";
import { LitElement } from "lit";
import {
  SlhCoreFocusTrappableInterface,
  FocusTrappable as SlhCoreFocusTrappable,
  SlhCoreFocusTrapTagMap,
} from "@slhuicore/base/focus-trap.js";

const FocusTrappable = <T extends Constructor<LitElement>>(superClass: T) => {
  class FocusTrappableElement extends SlhCoreFocusTrappable(superClass) {
    // eslint-disable-next-line class-methods-use-this
    getFocusableTags(): string[] {
      return [
        "slh-button",
        "slh-checkbox",
        "slh-datepicker",
        "slh-dropdown",
        "slh-dropdown-item",
        "slh-icon",
        "slh-link",
        "slh-navigation",
        "slh-navigation-item",
        "slh-rich-text-editor",
        "slh-textarea",
        "slh-textfield",
      ];
    }

    // eslint-disable-next-line class-methods-use-this
    getFocusableChildrenTags(): string[] {
      return ["slh-icon"];
    }

    // eslint-disable-next-line class-methods-use-this
    getFocusableTagMap(): SlhCoreFocusTrapTagMap {
      return {
        avatar: "slh-avatar",
        button: "slh-button",
        chip: "slh-chip",
        datepicker: "slh-datepicker",
        dropdown: "slh-dropdown",
        icon: "slh-icon",
        link: "slh-link",
        tabItem: "slh-tab-item",
        textarea: "slh-textarea",
        textfield: "slh-textfield",
      };
    }
  }

  return FocusTrappableElement as Constructor<SlhCoreFocusTrappableInterface> &
    T;
};

// eslint-disable-next-line import/prefer-default-export
export { FocusTrappable };
